/**
 * @author Matchexpo
 * @description 主题状态管理
 */
import { getActualTheme, getSystemTheme } from '@/utils/theme'

const state = () => ({
  themeMode: 'system', // 主题模式: 'light' | 'dark' | 'system'
  actualTheme: 'light', // 实际应用的主题: 'light' | 'dark'
  systemTheme: 'light' // 系统主题: 'light' | 'dark'
})

const getters = {
  themeMode: (state) => state.themeMode,
  actualTheme: (state) => state.actualTheme,
  systemTheme: (state) => state.systemTheme
}

const mutations = {
  changeThemeMode(state, themeMode) {
    state.themeMode = themeMode
    // 当主题模式改变时，同时更新实际主题
    state.actualTheme = getActualTheme(themeMode)
  },
  
  setActualTheme(state, actualTheme) {
    state.actualTheme = actualTheme
  },
  
  setSystemTheme(state, systemTheme) {
    state.systemTheme = systemTheme
    // 如果当前是跟随系统主题，则更新实际主题
    if (state.themeMode === 'system') {
      state.actualTheme = systemTheme
    }
  }
}

const actions = {
  setThemeMode: ({ commit }, themeMode) => {
    commit('changeThemeMode', themeMode)
  },
  
  setActualTheme: ({ commit }, actualTheme) => {
    commit('setActualTheme', actualTheme)
  },
  
  setSystemTheme: ({ commit }, systemTheme) => {
    commit('setSystemTheme', systemTheme)
  },
  
  // 初始化主题状态
  initThemeState: ({ commit, state }) => {
    const currentSystemTheme = getSystemTheme()
    commit('setSystemTheme', currentSystemTheme)
    
    const actualTheme = getActualTheme(state.themeMode)
    commit('setActualTheme', actualTheme)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
